// extracted by mini-css-extract-plugin
export default {"deleteWarning":"deleteWarning---kHcrZ","section":"section---C7l2N","list":"list---V2tBp","engagedMark":"engagedMark---DBAOo"};